export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6063.7a872ea8.jpg";